import React, { useState, useEffect, useRef, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import Loader from '../components/Loader.js'
import { registerUser } from '../actions/userActions.js'
import { logout } from '../actions/userActions.js'
import FormContainer from '../components/FormContainer.js'
import { USER_REGISTER_RESET } from '../constants/userConstants.js'
import { ThemeContext } from '../components/ThemeContext.js'

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

// import 'react-country-state-city/dist/react-country-state-city.css'

// Register Screen
const RegisterScreen = () => {
  const { theme } = useContext(ThemeContext)
  const [fname, setFname] = useState('')
  const [lname, setLname] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [country, setCountry] = useState('')
  const [mailcode, setMailcode] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)

  // Redux hooks
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const inputRef = useRef()

  // Get userRegister state from Redux store
  const userRegister = useSelector((state) => state.userRegister)
  const { loading, error, userInfo } = userRegister

  // useEffect to handle redirection after registration
  useEffect(() => {
    if (userInfo && !loading) {
      dispatch(logout(userInfo._id))
      navigate('/login')
    } else {
      dispatch({ type: USER_REGISTER_RESET })
      inputRef.current.focus()
    }
  }, [navigate, userInfo, dispatch, loading, error])

  // Form submit handler
  const submitHandler = (e) => {
    e.preventDefault()

    const userinfo = {
      fname,
      lname,
      email,
      phone,
      address,
      city,
      state,
      country,
      mailcode,
      password
    }

    if (
      fname === '' ||
      lname === '' ||
      email === '' ||
      phone === '' ||
      address === '' ||
      city === '' ||
      state === '' ||
      country === '' ||
      mailcode === ''
    ) {
      setMessage('Please enter all fields')
      return
    }

    if (
      password !== confirmPassword &&
      password.length >= 6 &&
      confirmPassword.length >= 6
    ) {
      setMessage('Passwords do not match')
      return
    }

    if (
      (password.length < 6 || confirmPassword.length < 6) &&
      password !== '' &&
      confirmPassword !== ''
    ) {
      setMessage('Password must be at least 6 characters')
      return
    }

    if (password === '' || confirmPassword === '') {
      setMessage('Password cannot be empty')
      return
    }

    if (
      password === confirmPassword &&
      (password !== '' || confirmPassword !== '') &&
      (password.length >= 6 || confirmPassword.length >= 6)
    ) {
      setMessage('Registration Successful')
      dispatch(registerUser(userinfo))
      setTimeout(() => {
        setMessage(null)
        navigate('/login')
      }, 2000)
    }
  }

  return (
    <FormContainer>
      <h3 className='my-2'>User Account Register</h3>

      {message &&
        password !== confirmPassword &&
        password.length >= 6 &&
        confirmPassword.length >= 6 && (
          <Alert variant='danger' dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}

      {message &&
        password === confirmPassword &&
        password !== '' &&
        password.length >= 6 &&
        confirmPassword.length >= 6 && (
          <Alert variant='success' dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}

      {message && (password === '' || confirmPassword === '') && (
        <Alert variant='warning' dismissible onClose={() => setMessage(null)}>
          {message}
        </Alert>
      )}

      {message && (password.length < 6 || confirmPassword.length < 6) && (
        <Alert variant='warning' dismissible onClose={() => setMessage(null)}>
          {message}
        </Alert>
      )}

      {error && (
        <Alert variant='danger' dismissible onClose={() => setMessage(null)}>
          {error}
        </Alert>
      )}

      {/* {error && <Message variant='danger'>{error}</Message>} */}
      {loading && <Loader />}

      <Form onSubmit={submitHandler}>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='fname'>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                ref={inputRef}
                type='fname'
                autoFocus
                placeholder='First Name'
                value={fname}
                onChange={(e) => setFname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='lname'>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type='lname'
                placeholder='Last Name'
                value={lname}
                onChange={(e) => setLname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='email'>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Email'
                autoComplete='on'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='phone'>
              <Form.Label>Phone Number</Form.Label>
              <PhoneInput
                placeholder='Enter phone number'
                value={phone}
                onChange={setPhone}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='address'>
              <Form.Label>Address</Form.Label>
              <Form.Control
                type='address'
                placeholder='Address'
                autoComplete='on'
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='city'>
              <Form.Label>City</Form.Label>
              <Form.Control
                type='city'
                placeholder='City'
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='state'>
              <Form.Label>State</Form.Label>
              <Form.Control
                type='state'
                placeholder=' State'
                value={state}
                onChange={(e) => setState(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='country'>
              <Form.Label>Country</Form.Label>
              {/* <CountrySelect
                type='country'
                placeholder='Select Country'
                autoComplete='on'
                value={country}
                onTextChange={setCountry}
                required
              /> */}

              <Form.Control
                type='country'
                placeholder='Country'
                autoComplete='on'
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='mailcode'>
              <Form.Label>Mail Code</Form.Label>
              <Form.Control
                type='mailcode'
                placeholder='Mail Code'
                value={mailcode}
                onChange={(e) => setMailcode(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='password'>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='(6 or more characters)'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='confirmPassword'>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='(6 or more characters)'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className='py-1'>
          <Col>
            <Button
              type='submit'
              variant='outline-primary'
              style={{
                borderColor: theme.accent,
                color: theme.accent,
                backgroundColor: 'transparent'
              }}
            >
              Register
            </Button>
            {pathname !== '/admin/user/register' && (
              <Button
                as={Link}
                to='/login'
                variant='outline-primary'
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent'
                }}
              >
                Login Here
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    </FormContainer>
  )
}

export default RegisterScreen
